import { render, staticRenderFns } from "./SalesBoostGuide.vue?vue&type=template&id=1268707f&scoped=true"
import script from "./SalesBoostGuide.vue?vue&type=script&lang=js"
export * from "./SalesBoostGuide.vue?vue&type=script&lang=js"
import style0 from "./SalesBoostGuide.vue?vue&type=style&index=0&id=1268707f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1268707f",
  null
  
)

export default component.exports